import "./footer.scss";

const Footer = () => {
    return (
        <div className="footer">
            <ul className="footer-container">
                <li>
                    <strong>회사명</strong> (주)버킷리스트클래스
                </li>
                <li>
                    <strong>주소</strong>
                    경제과학진흥원 광교로 107 창업혁신공간 401호
                </li>
                <li>
                    <strong>연락처</strong> 1555-6230
                </li>
                <li>
                    <strong>사업자 번호</strong> 623-81-03338
                </li>
                <li>
                    <strong>통신판매업번호</strong>  2024-강원춘천-0424
                </li>
                <li>
                    <strong>대표자</strong> 박동환
                </li>
                <li className="copyright">
                    Copyright 2025 Bucketlist. All rights reserved.
                </li>
            </ul>
        </div>
    );
};

export default Footer;
